import { createMutation, createQuery } from 'react-query-kit';

import * as Types from '../api/subscription/types.api';
import * as API from '../api/subscription/index.api';
import { queryClient } from 'src';

//
//

const key = 'subscriptions';

const invalidateQueryMerchantSubscription = (merchantCode: string) => {
  queryClient.invalidateQueries({
    queryKey: useQueryMerchantSubscriptionGet.getKey({ merchantCode }),
  });
};

//

export const useQuerySubscriptionsList = createQuery<
  Types.SubscriptionsResponse,
  Types.SubscriptionsQuery
>({
  queryKey: [key, 'list'],
  fetcher: (params) => API.getSubscriptionPlansAPI(params),
});

//

export const useQueryMerchantSubscriptionGet = createQuery<
  Types.MerchantSubscriptionsResponse,
  Types.SubscriptionsQuery
>({
  queryKey: [key, 'merchant'],
  fetcher: (params) => API.getSubscriptionsAPI(params),
});

//

export const useMutationSaasSubUpdate = createMutation<
  any,
  Types.CreateUpdateToAnnualSaasSubscriptionLink
>({
  mutationKey: [key, 'create-checkout-session'],
  mutationFn: (params) => API.updateSaasSubscriptionAPI(params),
  onSuccess: (_, variables) => invalidateQueryMerchantSubscription(variables.merchantCode),
});

//

export const useMutationSaasSubCreate = createMutation<any, Types.CreateCheckoutSessionSaasPayload>(
  {
    mutationKey: [key, 'create-checkout-session'],
    mutationFn: (params) => API.createSaasSubscriptionAPI(params),
    onSuccess: (_, variables) => invalidateQueryMerchantSubscription(variables.merchantCode),
  }
);

//

export const useMutationSaasSubCancel = createMutation<any, Types.CancelSubscriptionPayload>({
  mutationKey: [key, 'cancel'],
  mutationFn: (params) => API.cancelSubscriptionAPI(params),
  onSuccess: (_, variables) => invalidateQueryMerchantSubscription(variables.merchantCode),
});
